// Copyright (c) 2026 by Audere

import { LabelTask } from "../../label/labelTypes";
import {
  commonLabelingTasks,
  commonLabelingTypes,
  commonQuestions,
  translationLabelingTask,
  translationQuestions,
} from "./commonV2";

export const mangroveLabelingTypes = [
  ...commonLabelingTypes,
  {
    id: "isiZuluTranslationLabeling",
    name: "Translation labeling isiZulu",
    description: "Label the translation quality of isiZulu language",
    taskIDs: ["qualityOfTranslationLabeling"],
  },
] as const;

const mangroveLabelingTasks: LabelTask[] = [
  ...commonLabelingTasks,
  ...translationLabelingTask,
];

const mangroveQuestions = [...commonQuestions, ...translationQuestions];

export const mangroveLabelingSchemaV2 = {
  labelingTypes: mangroveLabelingTypes,
  labelingTasks: mangroveLabelingTasks,
  labelingQuestions: mangroveQuestions,
  labelingSchemaVersion: "mangroveLabelingSchemaV2",
};
